export default "__VITE_ASSET__Dsigx_C___"